// ------- Phone-Icon ------- //
export const PhoneIcon = () => (
  <svg
    width={36}
    height={37}
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3346_107630)">
      <path
        d="M35.25 17C35.0511 17 34.8603 16.921 34.7197 16.7803C34.579 16.6397 34.5 16.4489 34.5 16.25C34.5 8.393 28.107 2 20.25 2C20.0511 2 19.8603 1.92098 19.7197 1.78033C19.579 1.63968 19.5 1.44891 19.5 1.25C19.5 1.05109 19.579 0.860322 19.7197 0.71967C19.8603 0.579018 20.0511 0.5 20.25 0.5C28.935 0.5 36 7.565 36 16.25C36 16.4489 35.921 16.6397 35.7803 16.7803C35.6397 16.921 35.4489 17 35.25 17ZM30 16.25C30 10.874 25.626 6.5 20.25 6.5C20.0511 6.5 19.8603 6.57902 19.7197 6.71967C19.579 6.86032 19.5 7.05109 19.5 7.25C19.5 7.44891 19.579 7.63968 19.7197 7.78033C19.8603 7.92098 20.0511 8 20.25 8C24.7995 8 28.5 11.7005 28.5 16.25C28.5 16.4489 28.579 16.6397 28.7197 16.7803C28.8603 16.921 29.0511 17 29.25 17C29.4489 17 29.6397 16.921 29.7803 16.7803C29.921 16.6397 30 16.4489 30 16.25ZM33.351 33.9065L34.818 32.219C35.58 31.457 36 30.443 36 29.366C36 28.289 35.58 27.2735 34.7445 26.4485L31.0755 23.639C30.3185 22.8841 29.2933 22.4598 28.2242 22.4589C27.1551 22.4581 26.1292 22.8808 25.371 23.6345L23.073 25.8755C17.553 23.627 13.056 19.1255 10.632 13.421L12.864 11.1335C14.4375 9.56 14.4375 6.9995 12.9285 5.4995L9.99 1.685C8.4645 0.1595 5.7705 0.1955 4.32 1.6505L2.559 3.1865C0.9075 4.829 0 7.0595 0 9.464C0 21.0875 15.4125 36.5 27.036 36.5C29.4405 36.5 31.6695 35.5925 33.351 33.9065ZM8.8635 2.669L11.802 6.4835C12.2775 6.96104 12.544 7.60783 12.5429 8.28174C12.5417 8.95565 12.2731 9.60155 11.796 10.0775L9.213 12.7265C9.11152 12.8307 9.04248 12.9622 9.01425 13.1049C8.98603 13.2476 8.99984 13.3955 9.054 13.5305C11.6475 19.988 16.7235 25.0625 22.983 27.4505C23.1165 27.5016 23.2618 27.5136 23.4019 27.4849C23.5419 27.4562 23.6709 27.388 23.7735 27.2885L26.4225 24.7055L26.4285 24.698C27.387 23.738 28.9845 23.6765 30.0885 24.7625L33.7575 27.572C34.746 28.5605 34.746 30.1685 33.723 31.196L32.2545 32.8835C30.8925 34.2485 29.0385 35 27.036 35C16.296 35 1.5 20.204 1.5 9.464C1.5 7.4615 2.2515 5.6075 3.5805 4.28L5.343 2.7425C5.847 2.2385 6.5115 1.9925 7.1655 1.9925C7.7993 1.98521 8.41026 2.22895 8.865 2.6705L8.8635 2.669Z"
        fill="#00125B"
      />
    </g>
    <defs>
      <clipPath id="clip0_3346_107630">
        <rect
          width={36}
          height={36}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

// ------- Location-Icon ------- //
export const LocationIcon = () => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3346_107638)">
      <path
        d="M18.0005 36C15.9761 36.0057 14.0307 35.2154 12.584 33.7995L6.35595 28.0725C3.21795 24.948 1.50195 20.8215 1.50195 16.431C1.50195 12.0405 3.21945 7.914 6.33645 4.8105C9.45195 1.7085 13.5935 0 18.0005 0C22.4075 0 26.549 1.7085 29.666 4.812C32.783 7.9155 34.5005 12.0435 34.5005 16.4325C34.5005 20.8215 32.783 24.9495 29.666 28.053L23.402 33.816C21.9566 35.2238 20.0166 36.0085 17.999 36.0015L18.0005 36ZM18.0005 1.5C16.0311 1.49402 14.0801 1.87753 12.2595 2.62845C10.439 3.37938 8.7849 4.48289 7.39245 5.8755C4.56045 8.6955 3.00045 12.444 3.00045 16.4325C3.00045 20.421 4.56045 24.1695 7.39245 26.9895L13.6145 32.7105C15.9935 35.0295 20.021 35.0145 22.3715 32.7255L28.6295 26.9685C31.4405 24.1695 33.0005 20.4195 33.0005 16.4325C33.0005 12.4455 31.4405 8.6955 28.6085 5.8755C27.2159 4.48302 25.5618 3.3796 23.7413 2.62868C21.9208 1.87777 19.9697 1.49419 18.0005 1.5ZM17.339 20.3445L26.7785 11.034C26.9079 10.8917 26.978 10.7052 26.9741 10.5129C26.9701 10.3205 26.8926 10.137 26.7575 10.0001C26.6223 9.86324 26.4398 9.7834 26.2475 9.77705C26.0552 9.7707 25.8679 9.83832 25.724 9.966L16.2815 19.2795C16.211 19.3494 16.1274 19.4047 16.0355 19.4421C15.9436 19.4796 15.8451 19.4986 15.7459 19.4979C15.6466 19.4972 15.5485 19.4768 15.4571 19.4381C15.3657 19.3993 15.2829 19.3429 15.2135 19.272L10.274 14.4615C10.1309 14.3252 9.93981 14.2509 9.74224 14.2547C9.54468 14.2585 9.35659 14.3401 9.21886 14.4818C9.08112 14.6234 9.00487 14.8138 9.00667 15.0113C9.00846 15.2089 9.08816 15.3978 9.22845 15.537L14.1605 20.34C14.6 20.7795 15.176 20.9985 15.7535 20.9985C16.328 20.9985 16.904 20.7795 17.3405 20.343L17.339 20.3445Z"
        fill="#BC3F00"
      />
    </g>
    <defs>
      <clipPath id="clip0_3346_107638">
        <rect width={36} height={36} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------- Email-Icon ------- //
export const EmailIcon = () => (
  <svg
    width={36}
    height={37}
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3346_107646)">
      <path
        d="M33.9195 13.0505L22.9665 2.558C21.6405 1.232 19.8765 0.5 18 0.5C16.1235 0.5 14.3595 1.2305 13.0455 2.546L2.0805 13.0505C1.42414 13.6814 0.901633 14.4382 0.544179 15.2755C0.186724 16.1128 0.00164799 17.0136 0 17.924L0 29.75C0 33.4715 3.0285 36.5 6.75 36.5H29.25C32.9715 36.5 36 33.4715 36 29.75V17.924C36 16.094 35.2425 14.3165 33.9195 13.0505ZM3.117 14.1335L14.094 3.6185C15.1365 2.576 16.524 2 18 2C19.476 2 20.862 2.5745 21.9165 3.629L32.883 14.1335C32.9955 14.2415 33.102 14.354 33.204 14.471L21.7125 25.9625C19.7295 27.9455 16.272 27.9455 14.289 25.9625L2.796 14.471C2.898 14.354 3.0045 14.2415 3.117 14.1335ZM34.5 29.75C34.5 32.645 32.145 35 29.25 35H6.75C3.855 35 1.5 32.645 1.5 29.75V17.924C1.5 17.1755 1.6635 16.4375 1.968 15.7625L13.2285 27.023C14.5035 28.298 16.197 29 18.0015 29C19.806 29 21.4995 28.298 22.7745 27.023L34.035 15.7625C34.3395 16.4375 34.503 17.174 34.503 17.924V29.75H34.5Z"
        fill="#876A00"
      />
    </g>
    <defs>
      <clipPath id="clip0_3346_107646">
        <rect
          width={36}
          height={36}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

// ------- Facebook-Icon ------- //
export const FacebookIcon = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4653_167314)">
      <path
        d="M8.08433 14V7.61441H10.2268L10.5483 5.12509H8.08433V3.53603C8.08433 2.81554 8.28358 2.32453 9.31793 2.32453L10.635 2.32399V0.097461C10.4072 0.0678617 9.62539 0 8.71539 0C6.81517 0 5.51425 1.15988 5.51425 3.28949V5.12509H3.36523V7.61441H5.51425V14H8.08433Z"
        fill="#3D6AD6"
      />
    </g>
    <defs>
      <clipPath id="clip0_4653_167314">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------- TwitterX-Icon ------- //
export const TwitterXIcon = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4653_167317)">
      <path
        d="M8.30314 5.92804L13.4029 0H12.1944L7.7663 5.14724L4.22958 0H0.150391L5.4986 7.78354L0.150391 14H1.35894L6.03514 8.56434L9.77017 14H13.8494L8.30284 5.92804H8.30314ZM6.64787 7.85211L6.10598 7.07705L1.79439 0.909771H3.65065L7.13015 5.88696L7.67204 6.66202L12.195 13.1316H10.3387L6.64787 7.85241V7.85211Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4653_167317">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------- Instagram-Icon ------- //
export const InstagramIcon = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4653_167320)">
      <path
        d="M13.9579 4.11395C13.9238 3.36883 13.8055 2.85996 13.6325 2.41481C13.4567 1.94771 13.1812 1.52458 12.8251 1.17493C12.4754 0.818775 12.0523 0.54317 11.5852 0.367336C11.1399 0.194387 10.6312 0.0761523 9.88605 0.0423008C9.13957 0.0081211 8.90102 0 7 0C5.09898 0 4.86046 0.00812109 4.11395 0.0421094C3.36883 0.0761523 2.8601 0.194496 2.41481 0.367527C1.9477 0.543281 1.52456 0.818833 1.17491 1.17496C0.818751 1.52457 0.543145 1.94766 0.367309 2.41473C0.194359 2.86002 0.076125 3.36886 0.0422734 4.11387C0.0081211 4.86046 0 5.09887 0 6.99989C0 8.90102 0.0081211 9.13954 0.0423008 9.88602C0.0762617 10.6311 0.194605 11.1399 0.367637 11.5852C0.543388 12.0523 0.818931 12.4754 1.17504 12.825C1.52466 13.1811 1.94779 13.4566 2.41489 13.6324C2.8601 13.8055 3.36894 13.9237 4.11406 13.9578C4.86068 13.9919 5.09906 13.9999 7.00011 13.9999C8.90113 13.9999 9.13965 13.9919 9.88616 13.9578C10.6313 13.9237 11.14 13.8055 11.5853 13.6324C12.0503 13.4526 12.4726 13.1776 12.8251 12.825C13.1777 12.4725 13.4527 12.0502 13.6325 11.5852C13.8056 11.1399 13.9238 10.6311 13.9579 9.88605C13.9919 9.13943 14 8.90102 14 7C14 5.09887 13.9919 4.86046 13.9579 4.11395ZM12.6979 9.82871C12.6668 10.5112 12.5527 10.8819 12.4569 11.1285C12.3405 11.4304 12.1621 11.7046 11.9333 11.9334C11.7045 12.1622 11.4303 12.3406 11.1284 12.457C10.8817 12.5528 10.5111 12.6669 9.8286 12.698C9.09065 12.7317 8.86922 12.7388 7.00003 12.7388C5.13073 12.7388 4.90941 12.7317 4.17132 12.698C3.48893 12.6669 3.11831 12.5528 2.87156 12.457C2.56753 12.3448 2.29252 12.1658 2.06672 11.9333C1.83421 11.7076 1.65526 11.4325 1.54304 11.1285C1.44722 10.8819 1.33314 10.5112 1.30205 9.82871C1.26842 9.09065 1.26126 8.86922 1.26126 7.00014C1.26126 5.13092 1.26842 4.90962 1.30205 4.17143C1.33323 3.48893 1.44722 3.11828 1.54304 2.87167C1.6553 2.56761 1.83424 2.29256 2.06672 2.06672C2.29251 1.8342 2.56758 1.65529 2.87167 1.54314C3.11831 1.44722 3.48893 1.33325 4.17145 1.30205C4.90952 1.26842 5.13095 1.26126 7.00003 1.26126H6.99992C8.86903 1.26126 9.09043 1.26842 9.82863 1.30216C10.5111 1.33325 10.8817 1.44733 11.1284 1.54314C11.4324 1.6554 11.7074 1.8343 11.9332 2.06672C12.1658 2.29251 12.3447 2.56758 12.4568 2.87167C12.5527 3.11831 12.6668 3.48893 12.6979 4.17145C12.7315 4.90952 12.7387 5.13095 12.7387 7.00003C12.7387 8.86925 12.7316 9.09051 12.6979 9.82871Z"
        fill="url(#paint0_linear_4653_167320)"
      />
      <path
        d="M6.9998 3.40625C5.01462 3.40625 3.40527 5.01565 3.40527 7.00086C3.40527 8.98607 5.01462 10.5954 6.9998 10.5954C8.98512 10.5954 10.5944 8.98607 10.5944 7.00086C10.5944 5.01565 8.98509 3.40625 6.9998 3.40625ZM6.9998 9.33416C5.71123 9.33405 4.6665 8.28943 4.66661 7.00075C4.66661 5.71218 5.71123 4.66745 6.99991 4.66745C8.28859 4.66756 9.33321 5.71218 9.33321 7.00075C9.33321 8.28943 8.28848 9.33416 6.9998 9.33416Z"
        fill="url(#paint1_linear_4653_167320)"
      />
      <path
        d="M11.5765 3.26196C11.5765 3.72584 11.2004 4.1019 10.7365 4.1019C10.2726 4.1019 9.89648 3.72582 9.89648 3.26196C9.89648 2.79793 10.2726 2.42188 10.7365 2.42188C11.2004 2.42188 11.5765 2.79796 11.5765 3.26196H11.5765Z"
        fill="url(#paint2_linear_4653_167320)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4653_167320"
        x1="1.17485"
        y1="12.825"
        x2="12.8251"
        y2="1.17474"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopcolor="#FFD600" />
        <stop offset="0.5" stopcolor="#FF0100" />
        <stop offset={1} stopcolor="#D800B9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4653_167320"
        x1="4.45812"
        y1="9.54257"
        x2="9.54162"
        y2="4.45907"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopcolor="#FF6400" />
        <stop offset="0.5" stopcolor="#FF0100" />
        <stop offset={1} stopcolor="#FD0056" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4653_167320"
        x1="10.1426"
        y1="3.85586"
        x2="11.3305"
        y2="2.66794"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopcolor="#F30072" />
        <stop offset={1} stopcolor="#E50097" />
      </linearGradient>
      <clipPath id="clip0_4653_167320">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------- YouTube-Icon ------- //
export const YouTubeIcon = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4653_167325)">
      <path
        d="M11.0924 2.04688H2.90762C1.30178 2.04688 0 3.34866 0 4.9545V9.04601C0 10.6518 1.30178 11.9536 2.90762 11.9536H11.0924C12.6982 11.9536 14 10.6518 14 9.04601V4.9545C14 3.34866 12.6982 2.04688 11.0924 2.04688ZM9.12598 7.19932L5.2977 9.02518C5.19569 9.07383 5.07786 8.99945 5.07786 8.88645V5.12061C5.07786 5.006 5.19879 4.93172 5.30101 4.98353L9.12929 6.92351C9.24311 6.98118 9.24113 7.14441 9.12598 7.19932Z"
        fill="#F61C0D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4653_167325">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------- Pinrest-Icon ------- //
export const PinrestIcon = () => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4653_167328)">
      <path
        d="M7.00598 0C3.14332 0 0.0117188 3.13157 0.0117188 6.99426C0.0117188 9.95889 1.85384 12.4918 4.45579 13.5107C4.39246 12.9581 4.34064 12.1061 4.47881 11.5017C4.60547 10.9548 5.29625 8.02468 5.29625 8.02468C5.29625 8.02468 5.08902 7.60446 5.08902 6.98849C5.08902 6.01562 5.65317 5.2903 6.35547 5.2903C6.95416 5.2903 7.24198 5.73932 7.24198 6.27468C7.24198 6.87337 6.86204 7.77139 6.66057 8.60609C6.49364 9.30264 7.01172 9.87254 7.69676 9.87254C8.94019 9.87254 9.89577 8.56004 9.89577 6.67188C9.89577 4.99671 8.69265 3.82812 6.97144 3.82812C4.97967 3.82812 3.81108 5.31907 3.81108 6.86183C3.81108 7.46052 4.04134 8.10526 4.32916 8.45641C4.38672 8.52548 4.39249 8.58881 4.37521 8.65788C4.32339 8.87663 4.2025 9.35443 4.17948 9.4523C4.15069 9.57895 4.07585 9.60772 3.94345 9.54439C3.06845 9.13568 2.52157 7.86346 2.52157 6.83304C2.52157 4.62826 4.12189 2.60195 7.14412 2.60195C9.56765 2.60195 11.4558 4.32893 11.4558 6.64305C11.4558 9.05507 9.93605 10.995 7.82913 10.995C7.12107 10.995 6.4533 10.6266 6.22881 10.1891C6.22881 10.1891 5.87766 11.5246 5.79131 11.8527C5.63589 12.463 5.2099 13.2228 4.92205 13.6891C5.5783 13.8906 6.26909 13.9999 6.99444 13.9999C10.8571 13.9999 13.9887 10.8684 13.9887 7.00572C14.0002 3.13157 10.8686 0 7.00598 0Z"
        fill="#E60023"
      />
    </g>
    <defs>
      <clipPath id="clip0_4653_167328">
        <rect width={14} height={14} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
